import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { CentroService } from 'src/app/services/centro.service';
import { ContratistaService } from 'src/app/services/contratista.service';
import { MatDialog } from "@angular/material/dialog";
import { NgxFileDropEntry } from 'ngx-file-drop';
import moment from 'moment';
import { DocumentoService } from 'src/app/services/documento.service';
import { UploadDocumentosService } from 'src/app/services/upload-documentos.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { MatOption } from '@angular/material/core';
import { Xliff } from '@angular/compiler';
import { LoginService } from 'src/app/services/login.service';
import { LEADING_TRIVIA_CHARS } from '@angular/compiler/src/render3/view/template';
import { LicenciaService } from 'src/app/services/licencia.service';
import {PROVINCIAS} from './../../../../../constants/constants';
import { DocAdicionalService } from 'src/app/services/doc-adicional.service';

@Component({
  selector: 'app-nuevo-centro-contratista',
  templateUrl: './nuevo-centro-contratista.component.html',
  styleUrls: ['./nuevo-centro-contratista.component.scss']
})
export class NuevoCentroContratistaComponent implements OnInit {

  public files: NgxFileDropEntry[] = [];
  public fileName: any = []
  public documentos: NgxFileDropEntry[] = [];
  public url: any

  isLinear = false;
  datosCliente: any = {};
  datosCentro: any = {};
  datosCentro2: any = {};
  datosDocumento1: any = {};
  datosDocumento2: any = {};
  datosDocumento3: any = {};
  datosDocumento4: any = {};
  datosDocumento5: any = {};
  public clienteSeleccionado: any
  public instalacionSeleccionado: any = []
  public gestorSeleccionado: any = []
  public transportistaSeleccionado: any = []
  public clientes: any=[]
  public instalaciones: any
  public allInstalaciones: any = []
  public gestoresContratista: any
  public transportistasContratista: any
  public idGestorContratista: any
  public idTransportistaContratista: any
  public IdCliente: any[] = [];
  public idInstalacion: any[] = [];
  public centroId: any
  public centros: any[] = [];
  public IDcentros: any[] = [];
  public datepicker: any
  public datepicker1: any
  public datepicker2: any
  public datepicker3: any
  public datepicker4: any
  public datepicker5: any
  public datepicker6: any
  public datepicker7: any
  public datepicker8: any
  public datepicker9: any
  public datepicker10: any
  public otherDate: any
  public date: any
  public valuesDocumentos: any = [];
  contratista: any;
  idContratista: any;
  nameDocumento1:any
  nameDocumento2:any
  nameDocumento3:any
  nameDocumento4:any
  user:any
  licenciasPagadas:any
  customId: any
  idCentro:any
  residuosPeligrosos:any
  transportistasCliente:any
  gestoresCliente:any
  centrosClientes:any =[]
  fechaConfirmacion:any
  fechaCaducidad:any
  fechaRenovacion: any
  idClienteCustom:any
  lastLicencia:any 
  contadorLicencia:any
  provincias:any
  autonomia:any
  provincia:any
  docAdicional: any
  docAdicionalSolicitar: any
  centrosCliente: any
  centrosClienteDoc: any

  constructor(
    private formBuilder: FormBuilder, 
    private apollo: Apollo,
    private centroService: CentroService, 
    private contratistaService: ContratistaService,
    public dialog: MatDialog, 
    private documentoService: DocumentoService, 
    private uploadService: UploadDocumentosService, 
    private clienteService: ClienteService,
    private loginService: LoginService,
    private licenciaService: LicenciaService,
    private docAdicionalService: DocAdicionalService,) {
    this.buildForm();
    this.fechaConfirmacion = moment()
    this.fechaCaducidad = moment().add('days', 365)
    this.fechaRenovacion = moment().add('days', 335)
    this.provincias = PROVINCIAS
  }

  ngOnInit() {
    this.user = this.loginService.getUserData()
    this.contratista = this.loginService.getUserData()
    this.idContratista = this.contratista.contratista.id
    this.getLicenciasByContratista()
    this.getCentrosByContratista();
    this.getClientesByContrastita();
   setTimeout(() => {
    this.getContratistaById()
   
   }, 1000);
    
   
    
  }


  selectProvincia(e:any){
    if (e) {
      this.autonomia = e.value.COMUNIDAD_AUTONOMA;
      this.provincia = e.value.NOMBRE;
    }
    
  }

  private buildForm() {
    this.datosCliente = this.formBuilder.group({
      cliente: ['', [Validators.required]],
      instalacion: ['', [Validators.required]]
    });

    this.datosCentro = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      via: ['', [Validators.required]],
      nombreVia: ['', [Validators.required]],
      numero: ['', [Validators.required]],
      letra: [''],
      cp: ['', [Validators.required]],
      pta: [''],
      provincia: ['', [Validators.required]],
      ccaa: ['', [Validators.required]],
      nombreContacto: ['', [Validators.required]],
      mailContacto: ['', [Validators.required, Validators.email]],
    });
    this.datosCentro2 = this.formBuilder.group({
      nima: ['', [Validators.required]],
      resPeligrosos: [true, [Validators.required]],
      GPResPeligrosos: ['', [Validators.required]],
      gestores: ['', [Validators.required]],
      transportistas: ['', [Validators.required]]
    });
    this.datosDocumento1 = this.formBuilder.group({
      nombre: ['', Validators.required],
      fechaValidez: ['', Validators.required],
      fechaCaducidad: ['', Validators.required],
      noCaduca: ['', Validators.required]
    });
    this.datosDocumento2 = this.formBuilder.group({
      nombre: ['', Validators.required],
      fechaValidez: ['', Validators.required],
      fechaCaducidad: ['', Validators.required],
      noCaduca: ['', Validators.required]
    });
    this.datosDocumento3 = this.formBuilder.group({
      nombre: ['', Validators.required],
      fechaValidez: ['', Validators.required],
      fechaCaducidad: ['', Validators.required],
      noCaduca: ['',Validators.required ],
    });
    this.datosDocumento4 = this.formBuilder.group({
      nombre: ['', Validators.required],
      fechaValidez: ['', Validators.required],
      fechaCaducidad: ['', Validators.required],
      noCaduca: ['', Validators.required],
      policy: ['', Validators.required]
    });
    /* this.datosDocumento5 = this.formBuilder.group({
      nombre: ['', Validators.required],
      fechaValidez: ['', Validators.required],
      fechaCaducidad: ['', Validators.required],
      noCaduca: ['', Validators.required]
    }) */

  }

  fileLeave(e:any) {
    console.log(e)
  }
  fileOver(e:any) {
    console.log(e)
  }

  setValue(e:any){
    this.valuesDocumentos.push(e.target.id);
    console.log(this.valuesDocumentos)
  }

  dropped1(files: any){
    this.uploadService.dropped(files).subscribe((res:any)=>{
      this.nameDocumento1 = res[0].name;
      this.url = res[0].url
    })
    
   }
   dropped2(files: any){
    this.uploadService.dropped(files).subscribe((res:any)=>{
      this.nameDocumento2 = res[0].name;
      this.url = res[0].url
    })
    
   }
   dropped3(files: any){
    this.uploadService.dropped(files).subscribe((res:any)=>{
      this.nameDocumento3 = res[0].name;
      this.url = res[0].url
    })
    
   }
   dropped4(files: any){
    this.uploadService.dropped(files).subscribe((res:any)=>{
      this.nameDocumento4 = res[0].name;
      this.url = res[0].url
    })
    
   }

   getLicenciasByContratista() {
    this.apollo.watchQuery<any>({
      query: this.licenciaService.getLicenciasByContratista(),
      variables: {
        "id": this.user.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
       
        const licencias = data.contratista.licencias.filter((licencia:any)=>!licencia.IDLicencia)
        this.lastLicencia = licencias[licencias.length-1]
          }
      )
  }

  save(event: Event) {
    event.preventDefault();
    const value = this.datosCentro.value;
    console.log(value);
  }

  selectCliente(e:any){
    this.clienteSeleccionado = e;
    this.getClienteById()
    this.getInstalacionByContratista()
    this.getGestoresByContratista();
    this.getTransportistaByContratista();
  }

  selectAllInstalaciones(e:any){
   
    if (e) {
      const allInstalaciones = this.instalaciones;
      allInstalaciones.forEach((instalacion:any) => {
        this.instalacionSeleccionado.push(instalacion.id)
      });
    }else{
      this.instalacionSeleccionado = [];
    }
  }

  selectInstalacion(e:any){

    const instalacion= e.value;
    if (e.selected) {
      if (instalacion !=  null) {
        this.instalacionSeleccionado.push(instalacion)
      }
      
    }else{
      this.instalacionSeleccionado = this.instalacionSeleccionado.filter((i:any)=> i !== instalacion )
    }
  }

  selectAllGestores(e:any){

    if (e) { 
      const allGestores = this.gestoresContratista;
      allGestores.forEach((gestor:any) => {
        this.gestorSeleccionado.push(gestor.id)
      });
    }else{
      this.gestorSeleccionado = [];
    }   
  }

  selectGestores(e:any){
    const gestor = e.value;
    if (e.selected) {
      this.gestorSeleccionado.push(gestor)
    }else{
      this.gestorSeleccionado = this.gestorSeleccionado.filter((i:any)=> i !== gestor )
    }
  }
  
  selectAllTransportistas(e:any){
   
    if (e) {
      const allTransportistas = this.transportistasContratista;
      allTransportistas.forEach((transportista:any) => {
        this.transportistaSeleccionado.push(transportista.id)
      });   
    }else{
      this.transportistaSeleccionado = [];
    }
  }

  selectTransportistas(e:any){

    const transportista = e.value;
    if (e.selected) {
      this.transportistaSeleccionado.push(transportista)
      console.log(this.transportistaSeleccionado)
    }else{
      this.transportistaSeleccionado = this.transportistaSeleccionado.filter((i:any)=> i !== transportista) 
    }
  }

  getCentrosByContratista() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getCentrosByContratista(),
      variables: {
        "id": this.idContratista
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.centros = data.contratista.centros
        this.centros?.forEach(centro =>
          this.IDcentros.push(centro.id));
        if (data.contratista.centros[0] == undefined) {
          this.customId = 1
        }else{
          this.customId = data.contratista.centros[data.contratista.centros.length -1].customID +1
          
        }
      }
      )
  }

  getDate(fecha: any) {
    this.date = moment(new Date(fecha)).format('Y-MM-DD')
    console.log(this.date)
  }

  getOtherDate(fecha: any) {
    this.otherDate = moment(new Date(fecha)).format('Y-MM-DD')
    /* console.log(this.otherDate) */
  }
  

  getClienteById(){
    this.apollo.watchQuery<any>({
      query: this.clienteService.getClienteById(),
      variables: {
        "id": this.clienteSeleccionado
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data);
         this.residuosPeligrosos = data.cliente.resPeligrosos
         this.gestoresCliente = data.cliente.gestores
         this.transportistasCliente = data.cliente.transportistas
         this.centrosClientes = data.cliente.centros
         this.idClienteCustom = data.cliente.customID
         this.contadorLicencia = data.cliente.licencias.filter((licencia:any)=>!licencia.IDLicencia && licencia.contratista.id === this.idContratista ).length
         console.log(this.contadorLicencia);

         //INFORMACIÓN SOBRE LOS DOCUMENTOS ADICIONALES QUE HAY QUE CREAR EN EL CENTRO SOLICITADOS POR EL CLIENTE
        this.docAdicional = data.cliente.documentos_adicionals;
       console.log(this.docAdicional);
       this.docAdicionalSolicitar = data.cliente.documentos_adicionals.filter((doc:any)=>doc.firstTime == true)
       console.log(this.docAdicionalSolicitar);
       
       
         
      })
  }

  updateClienteById(centro:any) {
    let updateCentro =[]
    this.centrosClientes.forEach((centro:any) => {
      updateCentro.push(centro.id)
    });
    updateCentro.push(centro)
    console.log(updateCentro)
    console.log(this.clienteSeleccionado)
    this.apollo.mutate({
      mutation: this.clienteService.updateCliente(),
      variables: {
        "input": {
          "where": {
            "id": this.clienteSeleccionado
          },
          "data": {
            "centros":updateCentro
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa', error)
      })


  }

  addDocumentos() {
    for (let i = 0; i < this.valuesDocumentos.length; i++) {

      if (this.valuesDocumentos[i] == 'doc1') {
        if (this.datosDocumento1.value.noCaduca === '') {
          this.datosDocumento1.value.noCaduca = null
        }
        this.getDate(this.datosDocumento1.value.fechaValidez)
        if (this.datosDocumento1.value.fechaCaducidad) {
          this.getOtherDate(this.datosDocumento1.value.fechaCaducidad)
        }

        this.apollo.mutate<any>({
          mutation: this.documentoService.addDocumento(),
          variables: {
            "input": {
              "data": {
                "nombre": this.nameDocumento1,
                "fechaValidez": this.date,
                "fechaCaducidad": this.otherDate,
                "noCaduca": true,
                "obligatorio": true,
                "tipo": "pendiente",
                "nombreArchivo": "residuosPeligrosos",
                "centro": this.centroId,
                "url": this.url,
                "validado": false,
                "comentariosNuevos": true,
                "subidoPor": this.user.id
              }
            }
          }
        }).subscribe(({ data }) => {
          console.log('OK', data)
    
        }, (error) => {
          console.log('Error al lanzar la query', error);
        })
      }

      if (this.valuesDocumentos[i] == 'doc2') {
        if (this.datosDocumento2.value.noCaduca === '') {
          this.datosDocumento2.value.noCaduca = null
        }
        this.getDate(this.datosDocumento2.value.fechaValidez)
        if (this.datosDocumento2.value.fechaCaducidad) {
          this.getOtherDate(this.datosDocumento2.value.fechaCaducidad)
        }
        console.log(this.fileName)
        /* console.log(this.files) */
        this.apollo.mutate<any>({
          mutation: this.documentoService.addDocumento(),
          variables: {
            "input": {
              "data": {
                "nombre": this.nameDocumento2,
                "fechaValidez": this.date,
                "fechaCaducidad": this.otherDate,
                "noCaduca": true,
                "obligatorio": true,
                "tipo": "pendiente",
                "nombreArchivo": "residuosNoPeligrosos",
                "centro": this.centroId,
                "url": this.url,
                "validado": false,
                "comentariosNuevos": true,
                "subidoPor": this.user.id

              }
            }
          }
        }).subscribe(({ data }) => {
          console.log('OK', data)
    
        }, (error) => {
          console.log('Error al lanzar la query', error);
        })
      }

      if (this.valuesDocumentos[i] == 'doc3') {
        if (this.datosDocumento3.value.noCaduca === '') {
          this.datosDocumento3.value.noCaduca = null
        }
        this.getDate(this.datosDocumento3.value.fechaValidez)
        if (this.datosDocumento3.value.fechaCaducidad) {
          this.getOtherDate(this.datosDocumento3.value.fechaCaducidad)
        }
       
        /* console.log(this.files) */
        this.apollo.mutate<any>({
          mutation: this.documentoService.addDocumento(),
          variables: {
            "input": {
              "data": {
                "nombre": this.nameDocumento3,
                "fechaValidez": this.date,
                "fechaCaducidad": this.otherDate,
                "noCaduca": this.datosDocumento3.value.noCaduca,
                "obligatorio": true,
                "tipo": "pendiente",
                "nombreArchivo": "informeResiduos",
                "centro": this.centroId,
                "url": this.url,
                "validado": false,
                "comentariosNuevos": true,
                "subidoPor": this.user.id
              }
            }
          }
        }).subscribe(({ data }) => {
          console.log('OK', data)
    
        }, (error) => {
          console.log('Error al lanzar la query', error);
        })
      }

      if (this.valuesDocumentos[i] == 'doc4') {
        if (this.datosDocumento4.value.noCaduca === '') {
          this.datosDocumento4.value.noCaduca = null
        }
        this.getDate(this.datosDocumento4.value.fechaValidez)
        if (this.datosDocumento4.value.fechaCaducidad) {
          this.getOtherDate(this.datosDocumento4.value.fechaCaducidad)
        }
        
        /* console.log(this.files) */
        this.apollo.mutate<any>({
          mutation: this.documentoService.addDocumento(),
          variables: {
            "input": {
              "data": {
                "nombre": this.nameDocumento4,
                "fechaValidez": this.date,
                "fechaCaducidad": this.otherDate,
                "noCaduca": this.datosDocumento4.value.noCaduca,
                "obligatorio": true,
                "tipo": "pendiente",
                "nombreArchivo": "contratoTratamiento1",
                "centro": this.centroId,
                "url": this.url,
                "validado": false,
                "comentariosNuevos": true,
                "subidoPor": this.user.id
              }
            }
          }
        }).subscribe(({ data }) => {
          console.log('OK', data)
    
        }, (error) => {
          console.log('Error al lanzar la query', error);
        })
      }
    }

    
  }

  


  addCentro() {
    this.licenciasPagadas = this.licenciasPagadas -1 
    this.transportistaSeleccionado = Object.assign(this.transportistaSeleccionado)
    this.gestorSeleccionado = Object.assign(this.gestorSeleccionado)
    console.log()
    this.apollo.mutate<any>({
      mutation: this.centroService.addCentro(),
      variables: {
        "input": {
          "data": {
            "contratista": this.user.contratista.id,
            "nombre": this.datosCentro.value.nombre,
            "resPeligrosos": this.datosCentro2.value.resPeligrosos,
            "GPResPeligrosos": this.datosCentro2.value.GPResPeligrosos,
            "nima": this.datosCentro2.value.nima,
            "clientes": this.datosCliente.value.cliente,
            "contactoResponsable": {
              "nombre": this.datosCentro.value.nombreContacto,
              "mail": this.datosCentro.value.mailContacto,
            },
            "direccion": {
              "tipoVia": this.datosCentro.value.via,
              "nombre": this.datosCentro.value.nombreVia,
              "pta": this.datosCentro.value.pta,
              "numero": this.datosCentro.value.numero,
              "letra": this.datosCentro.value.letra,
              "provincia": this.provincia,
              "ccaa": this.datosCentro.value.ccaa,
              "codigoPostal": this.datosCentro.value.cp,
            },
            "instalaciones": this.instalacionSeleccionado,
            "transportistas": this.transportistaSeleccionado,
            "gestors": this.gestorSeleccionado,
            "IdCentro": this.idCentro,
            "customID": this.customId,
            
          }
        }
      }
    }).subscribe(({ data }) => {
      console.log('OK', data)
      this.IDcentros.push(data.createCentro?.centro.id)
      this.updateContratistaById();
      this.centroId = data.createCentro.centro.id
      
      
      setTimeout(() => {
        this.addDocumentos();
        this.updateLicencia(this.lastLicencia.id)
        location.reload()
      }, 1000);
      
      this.updateClienteById(this.centroId)
      if (this.docAdicionalSolicitar.length > 0) {
        for (let i = 0; i < this.docAdicionalSolicitar.length; i++) {
          this.updateDocumentoAdicional(this.docAdicionalSolicitar[i].id, this.centroId )  
         }
      }
      
      
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

//para poder añadir los doc adicionales hay que tener los centro del cliente y luego hacer un update con todos los centros en los doc adicionales
//incluyendo el centro que estamos agregando
  updateDocumentoAdicional(id: string, centro: any){
    console.log(this.centrosCliente);
    let actualizaCentro =[]
    this.centrosClientes.forEach((centro:any) => {
      actualizaCentro.push(centro.id)
    });
    actualizaCentro.push(centro)
    console.log(actualizaCentro)
    this.apollo.mutate({
      mutation: this.docAdicionalService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id,
          },
          "data": {
            "centros": actualizaCentro,
            
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  updateContratistaById() {
    this.apollo.mutate({
      mutation: this.contratistaService.updateContratista(),
      variables: {
        "input": {
          "where": {
            "id": this.idContratista
          },
          "data": {
            "centros": this.IDcentros,
            "licenciasPagadas": this.licenciasPagadas
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  getContratistaById(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getContratistaById(),
      variables: {
        "id": this.idContratista
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
      
        this.licenciasPagadas = data.contratista.licenciasPagadas
       
        this.idCentro = data.contratista.identificadorCO + data.contratista.customID +'/'+this.customId
        console.log(this.idCentro)
        
      })
  }



  getClientesByContrastita(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getClientesByContratista(),
      variables: {
        "id": this.idContratista
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        const clientes = data.contratista.clientes
        clientes.forEach((cliente:any) => {
          for (let i = 0; i < cliente.licencias.length; i++) {
            if (cliente.licencias[i].licenciaActiva == false) {
              
              
              this.clientes.push(cliente)
              break;
            }
            
          }
            
        
        });
        console.log(this.clientes);
        
        this.clientes?.forEach((cliente:any) => 
        this.IdCliente.push(cliente.id));
      
          }
      )
  }

  getInstalacionByContratista(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getInstalacionesByContratista(),
      variables: {
        "id": this.user.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.instalaciones = data.contratista.instalacions
        const filterInstalacion = this.instalaciones.filter((instalacion:any)=>instalacion.cliente.id == this.clienteSeleccionado)
        this.instalaciones = filterInstalacion
 
          }
      )
  }

  getGestoresByContratista(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getGestoresByContratista(),
      variables: {
        "id": this.idContratista
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.gestoresContratista = data.contratista.gestores
        this.gestoresContratista?.forEach((gestor:any) => 
        this.idGestorContratista?.push(gestor.id));
    
          }
      )
  }

  getTransportistaByContratista(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getTransportistasByContratista(),
      variables: {
        "id": this.idContratista
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data)
        this.transportistasContratista = data.contratista.transportistas
        this.transportistasContratista?.forEach((transportista:any) => 
        this.idTransportistaContratista?.push(transportista.id));
          }
      )
  }

  updateLicencia(id:any) {
    console.log(id);
    
    let codLicencia = 'XT/CL'+this.idClienteCustom+'/'+this.idCentro
    this.apollo.mutate({
        mutation: this.licenciaService.updateLicencia(),
        variables: {
          "input": {
            "where": {
              "id": id
            },
            "data": {
              "fechaConfirmacion": this.fechaConfirmacion,
              "fechaCaducidad": this.fechaCaducidad,
              "fechaRenovacion": this.fechaRenovacion,
              "centro": this.centroId,
              "cliente":this.clienteSeleccionado,
              "contratista": this.user.contratista.id,
              "licenciaActiva":true,
              "IDLicencia": codLicencia
             
            },
          },
        },
      })
      .subscribe(
        ({ data, errors }) => {
          
        },
        (error) => {
          console.log('Error al lanzar la query', error);
        }
      );
  }

  
}
        
      
  




